import type { ReactNode } from 'react'
import { Spinner } from './ui/Spinner'

export type TokenActionState = 'loading' | 'success' | 'error' | 'form'

/**
 * Zentrierte Karte für die öffentlichen Mail-Token-Seiten
 * (loading/success/error/form), max-w-md wie die Login-Karte.
 */
export function TokenActionCard({
    state = 'form',
    title,
    children,
}: {
    state?: TokenActionState
    title: string
    children?: ReactNode
}) {
    return (
        <div className='flex min-h-screen items-center justify-center bg-gradient-to-b from-indigo-50 to-slate-100 dark:from-slate-900 dark:to-slate-950 px-4'>
            <div className='w-full max-w-md rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-6 text-center shadow-sm'>
                {state === 'loading' && (
                    <>
                        <Spinner className='mx-auto h-8 w-8' />
                        <h1 className='mt-3 text-lg font-bold text-slate-800 dark:text-slate-100'>
                            {title}
                        </h1>
                    </>
                )}
                {state === 'success' && (
                    <>
                        <p className='text-4xl'>✓</p>
                        <h1 className='mt-2 text-lg font-bold text-slate-800 dark:text-slate-100'>
                            {title}
                        </h1>
                    </>
                )}
                {state === 'error' && (
                    <>
                        <p className='text-4xl text-red-500'>✕</p>
                        <h1 className='mt-2 text-lg font-bold text-red-700 dark:text-red-300'>
                            {title}
                        </h1>
                    </>
                )}
                {state === 'form' && (
                    <h1 className='text-lg font-bold text-slate-800 dark:text-slate-100'>
                        {title}
                    </h1>
                )}
                {children && (
                    <div className='mt-3 space-y-4 text-sm text-slate-500 dark:text-slate-400'>
                        {children}
                    </div>
                )}
            </div>
        </div>
    )
}
